import React from 'react';
import { Tag } from 'antd';
import styled from '@emotion/styled';
import { AccessCodeRecordInterface } from '../../../../types/accessCode';
import { appStyles } from '../../../../styles';

interface CodeColumnProps {
  record: AccessCodeRecordInterface;
}

export default React.memo((props: CodeColumnProps) => {
  const { record } = props;
  return (
    <StyledContainer>
      <Tag color={!record.userId ? '#00BE4B' : '#EEEEEE'} className={!record.userId ? 'active' : 'default'}>
        {record.code}
      </Tag>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  .ant-tag {
    width: 120px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    border-radius: 0;
    font-size: 14px;
    &.default {
      ${appStyles.color.black}
    }
  }
`;
